<div class="adv-ins-app">
  <layout></layout>
  <p-toast />
  <p-confirmDialog />
</div>
